const eckoAnalyticsDebug = false;

export function eckoLog(...args) {
	if (eckoAnalyticsDebug) {
		console.log('[Ecko analytics]', ...args);
	}
}

export function eckoDispatch(name, detail = {}) {
	eckoLog('event fired:', name, detail);
	window.dispatchEvent(new CustomEvent(name, { detail }));
}
